// lib/client.js
import { createClient } from '@sanity/client'

export const client = createClient({
  projectId: 'ckt2iy7e',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2023-07-28',
})
